import { RouteView,PageView } from '@/layouts'
export const invitedRecord =   {
    path: '/invitedRecord',
    name: 'invitedRecord',
    component: PageView,
    meta: { title: '终端邀请记录', icon: 'team', isMenuShow: true ,permission:'service'},
    children:[
        {
            path: '/invitedRecord/invitedRecord',
            name: 'invitedRecord',
            component: () => import('../views/invitedRecord/invitedRecord.vue'),
            meta: { title: '终端邀请记录', keepAlive: false, isMenuShow: true, permission:'service'},
        },
    ]
}
